import React from 'react';
import { Collapse } from 'react-bootstrap';

class KnowledgeArticle extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.handleClick = this.handleClick.bind(this);

        this.state = {
            open: this.props.openByDefault
        };
    }

    handleClick(e) {
        this.setState({ open: !this.state.open });
        e.preventDefault();
    }

    render() {
        let isArticleOpen = this.state.open;

        return (
            <div className="knowledge-article">
                <div className="title" onClick={this.handleClick}>
                    <a href="#"> {this.props.data.title} </a>
                    <i className={`arrow ${!isArticleOpen ? "down" : "up"}`} />
                </div>
                <Collapse in={isArticleOpen} className="content">
                    <div dangerouslySetInnerHTML={{ __html: this.props.data.content }}/>
                </Collapse>
            </div>
        );
    }
}
export default KnowledgeArticle;
